// extracted by mini-css-extract-plugin
export default {"heading":"LikOdS","left":"dyUMTR","right":"rFyn7G"};